<template>
  <div class="container p-t-50">
    <div class="card">
      <div class="card-content">
        <div class="columns">
          <div class="column is-2 has-text-centered">
            <b-icon class="has-text-success m-t-10" icon="check-circle" size="is-large"> </b-icon>
          </div>
          <div class="column">
            <p class="title is-3 m-b-15">Order Placed Successfully</p>
            <div v-for="order in orderID" v-bind:key="order">
            <p class="title is-5 m-b-15">Order ID : {{order}}</p>
            <router-link :to="{ name: 'KitOrderDetails', params: { kitType, orderID: order, status: 'PENDING' } }" class="button is-primary is-small" title="View Order details"
                  ><u>Click here for Order History</u>
                </router-link>
            <!-- <router-link slot="right" :to="{name:'KitOrderDetails', params:{ kitType, orderID:order}}">
              <u>Click here for Order History</u>
            </router-link> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
export default {
  name: 'wowKitOrderConfirmation',
  props: ['orderID', 'franchiseeID'],
  data () {
    return {
      kitType: null
    }
  },

  async created () {
    this.kitType = _.find(constants.KIT, item => _.isEqual(item.route, 'wow-kit')).route
    if (!this.orderID || !this.orderID.length) {
      this.$router.push({ name: 'wowKitOrderList' })
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  height: 100%;
  width: 40rem;
  margin: 0 auto;
  .card-content {
    padding: 3rem;
  }
}
</style>
